<mat-icon fontSet="ca" [fontIcon]="icon()"><ng-content></ng-content></mat-icon>
